import { render } from "./Articles.vue?vue&type=template&id=3911071b"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=3911071b&lang=css"
script.render = render

export default script